export default __webpack_public_path__ + "static/media/logo_tc.d04fc02e.svg";